export const HEIGHTS = {
    ACCOUNT_DROPDOWN: 45,
    HEADER_SCROLL_THRESHOLD: 24,
    NAV_MENU_ICON_BOTTOM_PADDING: 120,
    NAV_MENU_ICON_CONTAINER: 215,
};

export const AUTO_SIZE_OFFSETS = {
    RIGHT: 32, // Keep at 2rem to line this up with right edge of Entity Selector
    BOTTOM: 60,
    MIN_WIDTH: 40,
};

// The `xl` breakpoint defined by Tailwind is 1280. The widths below add up to 1280 as well, so any
// responsive design will involve adjustments based on the `xl` breakpoint being the standard width.
const XL_BREAKPOINT = 1280;
const LEFT_NAV = 180;
const MAIN_LEFT_MARGIN = 24;
const MAIN_RIGHT_MARGIN = 24;
// const SCROLLBAR = 14;

export const WIDTHS = {
    LEFT_NAV,
    MAIN_TOP_PADDING_XL: 260,
    MAIN_TOP_PADDING_LG: 128, // same as pt-32
    MAIN_TOP_PADDING_MD: 96, // same as pt-24
    MAIN_TOP_PADDING_SM: 24, // same as pt-6
    MAIN_TOP_PADDING_XS: 16, // same as pt-4
    MAIN_LEFT_MARGIN,
    MAIN_RIGHT_MARGIN,
    MAIN_XL: 1038,
    // MAIN_XL is calculated as follows. If any of these dimensions are changed, make sure to
    // change the value of theme.extend.width['main-xl'] in packages/styles/src/tailwindBaseConfig.js
    // MAIN_XL:
    //     XL_BREAKPOINT -
    //     LEFT_NAV -
    //     MAIN_LEFT_MARGIN -
    //     MAIN_RIGHT_MARGIN -
    //     SCROLLBAR,
    XL_BREAKPOINT,
};

export const TOP_PADDING_MAP = {
    xs: WIDTHS.MAIN_TOP_PADDING_XS,
    sm: WIDTHS.MAIN_TOP_PADDING_SM,
    md: WIDTHS.MAIN_TOP_PADDING_MD,
    lg: WIDTHS.MAIN_TOP_PADDING_LG,
    xl: WIDTHS.MAIN_TOP_PADDING_XL,
};
